<template>
<modal
  class="edit-modal"
  name="edit-modal"
  @before-open="setProcurement"
  transition="fade"
  :adaptive="true"
  :scrollable="true"
  :reset="true"
  width="40%"
  height="auto"
>
  <div style="display:flex;flex-direction:column;max-height:85vh;">
  <div id="modal-header" style="display:flex;align-items:flex-start;padding:20px 20px 16px;border-bottom:1px solid #EDEFF2;flex-shrink:0;">
    <p style="flex:1;margin:0;padding-right:40px;word-break:break-word;overflow-wrap:break-word;white-space:normal;line-height:1.5;font-size:14px;font-weight:600;color:#2D3036;">{{ procurement.cpv_name }} - {{ procurement.cpv_code }}</p>
    <button type="button"
            class="close"
            style="position:relative;top:0;right:0;flex-shrink:0;margin:0;padding:0;"
            @click="$modal.hide('edit-modal')" aria-label="Close">
      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ABAEB8"/>
      </svg>
    </button>
  </div>
  <div id="modal-body" style="padding:20px;overflow-y:auto;flex:1;">
    <form>
      <div class="form-group m-0">
        <div class="vfl-has-label">
          <label class="vfl-label" :class="procurement.cpv_type > 0 ? 'vfl-label-on-input' : ''" for="field-cpv-type">Գնման առարկայի տեսակ</label>
          <select v-model="procurement.cpv_type" class="tender-input form-control" id="field-cpv-type">
            <option disabled value="0">Գնման առարկայի տեսակ</option>
            <option value="1">Ապրանք</option>
            <option value="2">Ծառայություն</option>
            <option value="3">Աշխատանք</option>
          </select>
        </div>
      </div>
      <div class="form-group m-0">
        <div class="vfl-has-label">
          <label class="vfl-label" :class="details.type > 0 ? 'vfl-label-on-input' : ''" for="field-type">Գնման ձև</label>
          <select v-model="details.type" class="tender-input form-control" id="field-type">
            <option disabled value="0">Գնման ձև</option>
            <option v-for="(type, key) in purchaseTypesForItenderLongNames" :key="key" :value="+key" :disabled="key === '2' && !showAuctions">{{ type }}</option>
          </select>
        </div>
      </div>
      <div class="form-group m-0">
        <div class="vfl-has-label">
          <label class="vfl-label" :class="procurement.user_id != null ? 'vfl-label-on-input' : ''" for="field-user-id">{{ division.childName }}</label>
          <select v-model="procurement.user_id" class="tender-input form-control" id="field-user-id">
            <option disabled :value="null">{{ division.childName }}</option>
            <option :key="child.id" v-for="child in userChildren" :value="child.id">{{ child.name.hy || child.name.ru || child.name.en || "" }}</option>
          </select>
        </div>
      </div>
      <div class="form-group m-0">
        <float-label>
          <select v-model="procurement.unit" class="tender-input form-control" id="field-unit">
            <option disabled selected value="0">Չափման միավոր</option>
            <option :key="unit.id" v-for="unit in units" :value="unit.id">{{ unit.title }}</option>
          </select>
        </float-label>
      </div>
      <div class="form-group m-0">
        <float-label>
          <input
            v-model.number="$v.details.unit_amount.$model"
            :class="{'border-danger': unitAmountRequired}"
            placeholder="Միավորի գին"
            v-positive-only
            type="text"
            class="tender-input"
            id="field-unit-amount"
          >
        </float-label>
      </div>
      <div class="form-group m-0">
        <float-label>
          <input
            v-model="$v.details.count.$model"
            :class="{'border-danger': countRequired}"
            placeholder="Քանակ"
            v-positive-only.none_zero.integer
            type="text"
            class="tender-input"
            id="field-count"
          >
        </float-label>
      </div>
      <div class="form-group m-0">
        <float-label>
          <input
            v-model="$v.details.out_count.$model"
            :class="{'border-danger': outCountRequired}"
            placeholder="Համակարգից դուրս կազմակերպված քանակ"
            v-positive-only.none_zero.integer
            type="text"
            class="tender-input"
            id="field-out-count"
          >
        </float-label>
      </div>
      <div class="form-group m-0">
        <div class="vfl-has-label">
          <label class="vfl-label" :class="details.date && 'vfl-label-on-input vfl-label'" for="field-date">Գնման ժամկետ</label>
          <date-pick
            v-model="details.date"
            :displayFormat="'DD/MM/YYYY'"
            :inputAttributes="{readonly: true, placeholder: 'Գնման ժամկետ', id: 'field-date'}"
            :weekdays="['Երկ', 'Երք', 'Չոր', 'Հին', 'Ուր', 'Շբթ', 'Կիր']"
            :months="['Հունվար', 'Փետրվար', 'Մարտ', 'Ապրիլ', 'Մայիս', 'Հունիս', 'Հուլիս', 'Օգոստոս', 'Սեպտեմբեր', 'Հոկտեմբեր', 'Նոյեմբեր', 'Դեկտեմբեր']"
            :isDateDisabled="(date) => date < new Date()"
            class="tender-date-picker date-picker"
          />
        </div>
      </div>
      <div class="form-group m-0">
        <div class="vfl-has-label">
          <label class="vfl-label" :class="details.supply_date && 'vfl-label-on-input vfl-label'" for="field-supply-date">Մատակ. ժամկետ</label>
          <date-pick
            v-model="details.supply_date"
            :displayFormat="'DD/MM/YYYY'"
            :inputAttributes="{readonly: true, placeholder: 'Մատակ. ժամկետ', id: 'field-supply-date'}"
            :weekdays="['Երկ', 'Երք', 'Չոր', 'Հին', 'Ուր', 'Շբթ', 'Կիր']"
            :months="['Հունվար', 'Փետրվար', 'Մարտ', 'Ապրիլ', 'Մայիս', 'Հունիս', 'Հուլիս', 'Օգոստոս', 'Սեպտեմբեր', 'Հոկտեմբեր', 'Նոյեմբեր', 'Դեկտեմբեր']"
            class="tender-date-picker date-picker"
          />
        </div>
      </div>
      <div class="form-group m-0">
        <float-label>
          <textarea v-model="details.notes" class="tender-input form-control" id="field-notes" placeholder="Նշումներ" rows="2" style="min-height:60px"></textarea>
        </float-label>
      </div>
    </form>
  </div>
  <div id="modal-footer" style="flex-shrink:0;">
    <button @click="$modal.hide('edit-modal')" type="button" class="btn btn-secondary mr-3"><span>Չեղարկել</span></button>
    <button @click="update" type="button" class="btn btn-primary"><span>Պահպանել</span></button>
  </div>
  </div>
</modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import PurchaseTypes from '@/mixins/purchaseTypes'
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';

export default {
  name: 'ProcurementEditModal',
  components: { DatePick },
  mixins: [PurchaseTypes],
  computed: {
    units() {
      return this.$store.getters['settings/units']
    },
    unitAmountRequired () {
      return this.$v.details.unit_amount.$dirty && !this.$v.details.unit_amount.required
    },
    countRequired () {
      return this.$v.details.count.$dirty && !this.$v.details.count.required
    },
    outCountRequired () {
      return this.$v.details.out_count.$dirty && !this.$v.details.out_count.required
    },
    division() {
      return this.$store.getters['user/division']
    },
    userChildren() {
      return this.$store.getters["user/responsibleUnits"]
    },
    showAuctions() {
      const me = this.$store.getters['user/me']
      return Boolean(me && me.show_auctions)
    },
  },
  data() {
    return {
      modalTitle: '',
      procurement: {},
      details: {},
      unchagedProcurement: {},
      unchagedDetails: {},
      isRowUpdated: false,
    }
  },
  methods: {
    setProcurement({ params: { row, updateTable } }) {
      // eslint-disable-next-line no-undef
      this.details = _.pick(row, [
        "order_index",
        "id",
        "count",
        "out_count",
        "unit_amount",
        "type",
        "date",
        "supply_date",
        "notes",
        "classifier",
        "financial_classifier",
      ])

      const t = +this.details.type
      this.details.type = [1, 2, 3].includes(t) ? t : 3
      if (!this.details.unit_amount) this.details.unit_amount = 0
      if (!this.details.out_count) this.details.out_count = 0

      // eslint-disable-next-line no-undef
      this.procurement = _.pick(row, [
        'plan_row_id',
        'status',
        'cpv_id',
        'cpv_name',
        'cpv_code',
        'cpv_drop',
        'cpv_type',
        'supply_date',
        'notes',
        'specifications_id',
        'unit',
        'is_condition',
        'condition_type'
      ])
      const unit = this.units.find(value => value.title === this.procurement.unit)
      this.$set(this.procurement, 'user_id', row.user ? (row.user.id !== undefined ? row.user.id : row.user) : null)
      this.$set(this.procurement, 'unit', unit ? unit.id : null)

      this.updateTable = updateTable

      // eslint-disable-next-line no-undef
      this.unchagedProcurement = _.cloneDeep(this.procurement)
      // eslint-disable-next-line no-undef
      this.unchagedDetails = _.cloneDeep(this.details)
    },
    async update() {
      if(this.$v.details.$invalid) {
        return
      }
      const changedProcurement = this.getChanges('unchagedProcurement', 'procurement')
      const changedDetails = this.getChanges('unchagedDetails', 'details')
      let updateResponse
      // eslint-disable-next-line no-undef
      if(!_.isEmpty(changedProcurement)) {
        updateResponse = await this.$store.dispatch('procurement/update', {
          rowId: this.procurement.plan_row_id,
          data: Object.assign({}, changedProcurement, {user_id: this.procurement.user_id})
        })
      }
      // eslint-disable-next-line no-undef
      if(!_.isEmpty(changedDetails)) {
        updateResponse = await this.$store.dispatch('procurement/updateDetails', {
          detailsId: this.details.id,
          data: changedDetails
        })
      }

      if(updateResponse) {
        if(updateResponse.data.status) {
          this.updateTable()
          this.$modal.hide('edit-modal')
        }
      } else {
        this.$modal.hide('edit-modal')
      }
    },
    getChanges(unchaged, changed) {
      const changesObj = {}
      Object.keys(this[unchaged]).forEach(key => {
        if(this[unchaged][key] !== this[changed][key]) {
          changesObj[key] = this[changed][key]
        }
      })
      return changesObj
    },
  },
  validations: {
    details: {
      unit_amount: { required },
      count: { required },
      out_count: { required },
    }
  }
}
</script>

<style scoped>
.date-picker {
  display: block;
  width: 100%;
  border: 1px solid #e8ebf3;
  border-radius: .25rem;
  border-bottom: 1px solid #e8ebf3;
}
.edit-modal-header {
  display: flex;
  align-items: flex-start;
  padding: 1rem 1.25rem;
  position: relative;
}
.edit-modal-title {
  flex: 1;
  padding-right: 2rem;
}
.edit-modal-title p {
  margin: 0;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
  font-size: 14px;
  font-weight: 600;
}
.edit-modal-close {
  position: absolute;
  right: 1.25rem;
  top: 1rem;
  flex-shrink: 0;
}
</style>
